export let handleAxios = (axios, urlParams) => {
  //  initial axios
  //  https://github.com/axios/axios
  switch (process.env['REACT_APP_CHANNEL']) {
    case 'haiou':
      axios.defaults.baseURL = process.env['REACT_APP_BUILD_ENV'] === 'production' ? 'http://api.wsgold.com.cn:8443/api' : 'http://api.bl.dev.seedtecgz.com/api'
      break
    case 'ytyg':
      axios.defaults.baseURL = process.env['REACT_APP_BUILD_ENV'] === 'production' ? 'http://api.dev.yt.hnytysjs.com/api' : 'http://api.dev.yt.hnytysjs.com/api'
      break
    case 'qxtj':
    case 'qxyg':
    case 'qxdg':
      axios.defaults.baseURL = process.env['REACT_APP_BUILD_ENV'] === 'production' ? 'https://api.hnjcwlkj.cn/api' : 'http://api.dev.hnjcwlkj.cn/api'
      break
    case 'tjyg':
      axios.defaults.baseURL = process.env['REACT_APP_BUILD_ENV'] === 'production' ? 'https://yg.api.hrbgjs.com/api' : 'http://api.dev.hnjcwlkj.cn/api'
      break
    case 'tradeasy':
      axios.defaults.baseURL = process.env['REACT_APP_BUILD_ENV'] === 'production' ? 'https://api.hnqcwlkj.com/api' : 'http://apit.dev.jltxjh.cn/api'
      break
    case 'trading':
      axios.defaults.baseURL = process.env['REACT_APP_BUILD_ENV'] === 'production' ? 'http://nm.api.seedtecgz.com/api' : 'http://nm.api.seedtecgz.com/api'
      break
    default:
      // xiniu & xibei & wanshun & youpin & dyyg
      axios.defaults.baseURL = process.env['REACT_APP_BUILD_ENV'] === 'production' ? 'https://api.hnqcwlkj.com/api' : 'http://api.dev.hnqcwlkj.com/api'
  }
  // axios.defaults.baseURL = 'https://api.szwanxin.com.cn/api'
  // axios.defaults.baseURL = 'https://api.mjsjs.cn/api'
  // axios.defaults.baseURL = 'http://192.168.0.7:8080/api'
  // axios.defaults.headers.get['cache-control'] = 'public,max-age=3600'

  // console.group('handle axios')
  // console.log(axios.defaults)
  // console.log(axios.defaults.headers)
  // console.groupEnd()

  axios.setToken = function (token) {
    //  此处Bearer后带空格 艹
    this.defaults.headers.common['Authorization'] = `Bearer ${token}`
    sessionStorage.setItem('token', token)
  }.bind(axios)
  axios.getToken = function () {
    let str = this.defaults.headers.common['Authorization']
    if (!str) {
      return ''
    } else {
      return str.slice(7)
    }
  }
  axios.clearToken = function () {
    this.defaults.headers.common['Authorization'] = null
    sessionStorage.setItem('token', null)
  }
  if (process.env['NODE_ENV'] === 'development') {
    //
    // let token = 'eyJhbGciOiJIUzUxMiJ9.eyJpc3MiOiJhcHAiLCJzdWIiOiJ7XCJhdXRob3JpdGllc1wiOltcIlJPTEVfVVNFUlwiXSxcImlkXCI6XCI4NDNcIixcInVzZXJuYW1lXCI6XCIxMzcwMDAwMDAwNVwifSIsImF1ZCI6IjEzNzAwMDAwMDA1IiwiaWF0IjoxNzE0MzgxMjg0fQ.cprSqJ0u7yRrv1xb_kpqlW65-fQIeup-31kDqvLF2zZ6p0qQsQJIaOfKDhMTazbEUOxss7BfxnVs99Jr4RaoGA'
    // 13700000005
    // let token = 'eyJhbGciOiJIUzUxMiJ9.eyJpc3MiOiJhcHAiLCJzdWIiOiJ7XCJhdXRob3JpdGllc1wiOltcIlJPTEVfVVNFUlwiXSxcImlkXCI6XCI4NDNcIixcInVzZXJuYW1lXCI6XCIxMzcwMDAwMDAwNVwifSIsImF1ZCI6IjEzNzAwMDAwMDA1IiwiaWF0IjoxNzA1MDI2NzQ3fQ.ztnOFszmITVxN3r_VEDudfTCCIsBhtgxQIjOLV_v9LkqCvvpocE4SwQzcch2yydQEg5mERq88Oo-OUOPQxvKUA'
    // 13243875384
    // let token = 'eyJhbGciOiJIUzUxMiJ9.eyJpc3MiOiJhcHAiLCJzdWIiOiJ7XCJhdXRob3JpdGllc1wiOltcIlJPTEVfVVNFUlwiXSxcImlkXCI6XCI4NzBcIixcInVzZXJuYW1lXCI6XCIxMzI0Mzg3NTM4M1wifSIsImF1ZCI6IjEzMjQzODc1MzgzIiwiaWF0IjoxNzA3MzU4MzQxfQ.oXUEHoxakvtkVoQJtyPfBhgstGzjUe1_Q16LU0Gc3N1DCeXfiaTWhwoR7pA4_TUGdVAEkLqnBpGQG2gQ7lSSnQ'
    // 13243875383
    // let token = 'eyJhbGciOiJIUzUxMiJ9.eyJpc3MiOiJhcHAiLCJzdWIiOiJ7XCJhdXRob3JpdGllc1wiOltcIlJPTEVfVVNFUlwiXSxcImlkXCI6XCI4NzBcIixcInVzZXJuYW1lXCI6XCIxMzI0Mzg3NTM4M1wifSIsImF1ZCI6IjEzMjQzODc1MzgzIiwiaWF0IjoxNzA5NzE2OTcwfQ.0Cw9eWFrJnZcZYk-GhIOiQJPdV9PNzRo_upQ7dOgZ4NaT3kJ6nJiUf4dj1uCv0JLnLNcZbzbbLU3WAedvyXmDQ'
    // 13177711676
    // const token = 'eyJhbGciOiJIUzUxMiJ9.eyJpc3MiOiJhcHAiLCJzdWIiOiJ7XCJhdXRob3JpdGllc1wiOltcIlJPTEVfVVNFUlwiXSxcImlkXCI6XCI3ODRcIixcInVzZXJuYW1lXCI6XCIxNTYyMjIzODc3NVwifSIsImF1ZCI6IjE1NjIyMjM4Nzc1IiwiaWF0IjoxNzM1MDM0ODQ4LCJleHAiOjE3MzU0NjY4NDh9.Xrojwm58-hul_hB8vI_Fgx6L-TZZ3T7OYan5wceTpsZMwGrS2iZ4iWVajGQlgc57IJqubQUTTTE0Kwg-nlhOxg'
    // 156

    // axios.setToken(token)
  }
  if (urlParams.get('token')) {
    // axios.defaults.headers.common['Authorization'] = `Bearer ${urlParams.get('token')}`
    axios.setToken(urlParams.get('token'))
  } else if (sessionStorage.getItem('token')) {
    axios.setToken(sessionStorage.getItem('token'))
  }
  axios.request = function (config) {
    if (!config.method) config.method = 'get'
    let { method, url, data, params } = config
    let t = this
    // 设置延时防止闪屏优化交互
    return new Promise((resolve) => {
      setTimeout(function () {
        resolve(t(config).then((response) => {
          console.group(`%c ${method}: ${url}`, 'color:#b175d6')
          console.log(data || params || null)
          console.log(response)
          console.groupEnd()
          let reason = ''
          if (response.status !== 200) {
            reason = `状态异常[status:${response.status}]`
          } else if (response.data === undefined) {
            reason = `无返回数据[status:${response.status}]`
          } else if (response.data['code'] !== 200) {
            reason = `${response.data['msg']}`
          } else {
            return response.data['data']
          }
          throw new Error(reason)
        }))
      }, 600)
    })
  }
}
